(function () {
    document.addEventListener('click', (e) => {
        const t = e.target.closest('.tree__toggle');
        if (!t) return;
        const item = t.closest('[data-tree-item]');
        const children = item?.querySelector(':scope > .tree__children');
        if (children) children.hidden = !children.hidden;
        t.setAttribute('aria-expanded', String(!children?.hidden));
    });
})();
